module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'roleManager'
      }
    }
  }, [_vm._v("角色管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("角色资源配置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "tree",
    staticClass: "menutree",
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.data2,
      "props": _vm.defaultProps,
      "node-key": "id",
      "default-checked-keys": _vm.checked,
      "show-checkbox": "",
      "default-expand-all": "",
      "expand-on-click-node": false
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dd39339!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/ConfigResource.vue
// module id = 1077
// module chunks = 2